import { DIFFICULTY_LEVELS, QUESTION_TYPES } from '../questionTypes';

// 30 Preguntas del Músculo Milohioideo
// 10 Básicas + 10 Generales + 10 Complejas

export const milohioideoQuestions = [
  
  // ========== NIVEL BÁSICO (10) ==========
  
  {
    id: 10301,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Qué significa el nombre 'milohioideo'?",
    options: [
      "Músculo del hueso hioides",
      "Músculo molar del hioides",
      "Elevador del hioides",
      "Depresor del hioides"
    ],
    correctAnswer: 1,
    explanation: "El nombre 'milohioideo' significa 'músculo molar del hioides' en griego, refiriéndose a su inserción en la línea milohioidea de la mandíbula (cerca de los molares) y su conexión con el hueso hioides. Forma el suelo de la boca junto con el digástrico."
  },
  
  {
    id: 10302,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se origina el milohioideo?",
    options: [
      "Línea milohioidea de la mandíbula",
      "Apófisis geni de la mandíbula",
      "Fosa submandibular",
      "Apófisis coronoide"
    ],
    correctAnswer: 0,
    explanation: "El milohioideo se origina en la línea milohioidea de la mandíbula, una cresta ósea que se extiende desde el agujero mentoniano hasta cerca del último molar. Esta inserción mandibular permite al músculo formar el diafragma oral."
  },
  
  {
    id: 10303,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cuál es la función principal del milohioideo?",
    options: [
      "Elevación del hueso hioides",
      "Depresión del hueso hioides",
      "Movimiento lateral de la mandíbula",
      "Protrusión lingual"
    ],
    correctAnswer: 0,
    explanation: "La función principal del milohioideo es la elevación del hueso hioides durante la deglución y fonación. Actúa como parte del suelo de la boca, elevando el hioides para abrir la epiglotis y proteger las vías aéreas."
  },
  
  {
    id: 10304,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Qué nervio inerva al milohioideo?",
    options: [
      "Nervio milohioideo",
      "Nervio hipogloso",
      "Nervio lingual",
      "Nervio alveolar inferior"
    ],
    correctAnswer: 0,
    explanation: "El milohioideo es inervado por el nervio milohioideo, una rama del nervio mandibular del trigémino (V3). Este nervio también inerva al vientre anterior del digástrico, formando el asa milohioidea."
  },
  
  {
    id: 10305,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué arteria irriga principalmente al milohioideo?",
    options: [
      "Arteria alveolar inferior",
      "Arteria submentoniana",
      "Arteria milohioidea",
      "Arteria lingual"
    ],
    correctAnswer: 2,
    explanation: "La arteria milohioidea, rama de la arteria alveolar inferior, irriga el milohioideo. Esta arteria atraviesa el conducto milohioideo en la mandíbula y proporciona irrigación al músculo y al hueso adyacente."
  },
  
  {
    id: 10306,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué estructura se encuentra entre los músculos milohioideos derecho e izquierdo?",
    options: [
      "Lengua",
      "Glándula submandibular",
      "Diafragma oral",
      "Genihioideos"
    ],
    correctAnswer: 2,
    explanation: "Los músculos milohioideos derecho e izquierdo se unen en la línea media formando el diafragma oral (suelo de la boca). Entre ellos se encuentra el septum lingual y estructuras vasculonerviosas importantes."
  },
  
  {
    id: 10307,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Qué tipo de músculo es el milohioideo?",
    options: [
      "Músculo suprahioideo",
      "Músculo infrahioideo",
      "Músculo faríngeo",
      "Músculo masticatorio"
    ],
    correctAnswer: 0,
    explanation: "El milohioideo es un músculo suprahioideo porque se encuentra por encima del hueso hioides. Forma parte del suelo de la boca y contribuye al soporte de la lengua y estructuras faríngeas."
  },
  
  {
    id: 10308,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se inserta el milohioideo?",
    options: [
      "Cuerpo del hueso hioides",
      "Apófisis estiloides",
      "Apófisis mastoides",
      "Hueso hioides y rafe medio"
    ],
    correctAnswer: 3,
    explanation: "El milohioideo se inserta en el cuerpo del hueso hioides y en el rafe milohioideo (línea media fibrosa). Esta inserción permite al músculo elevar el hioides y formar el soporte para la lengua."
  },
  
  {
    id: 10309,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Qué papel juega el milohioideo en la masticación?",
    options: [
      "Elevación de la mandíbula",
      "Estabilización del suelo de la boca",
      "Movimiento lateral de la mandíbula",
      "Protrusión mandibular"
    ],
    correctAnswer: 1,
    explanation: "El milohioideo estabiliza el suelo de la boca durante la masticación, previniendo el colapso de las estructuras blandas y manteniendo la posición de la lengua. Actúa como soporte para los movimientos mandibulares."
  },
  
  {
    id: 10310,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Por qué el milohioideo es importante en la succión?",
    options: [
      "Crea vacío en la boca",
      "Eleva la lengua",
      "Sella el istmo faríngeo",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "El milohioideo es importante en la succión porque crea vacío en la boca al elevarse, eleva la lengua para dirigir el flujo, y sella el istmo de las fauces junto con los músculos constrictores. Es esencial en lactantes para la alimentación."
  },
  
  // ========== NIVEL GENERAL (10) ==========
  
  {
    id: 10311,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cómo contribuye el milohioideo a las fases de la deglución?",
    options: [
      "Solo en fase oral",
      "En fases oral y faríngea",
      "Solo en fase esofágica",
      "No contribuye directamente"
    ],
    correctAnswer: 1,
    explanation: "El milohioideo contribuye a las fases oral y faríngea de la deglución: en la fase oral eleva el hioides para iniciar el bolo, y en la fase faríngea mantiene la elevación para proteger las vías aéreas superiores."
  },
  
  {
    id: 10312,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué músculos forman el triángulo submandibular junto con el milohioideo?",
    options: [
      "Digástrico y hiogloso",
      "Genihioideo y estilohioideo",
      "Milohioideo contralateral",
      "Todos los anteriores"
    ],
    correctAnswer: 0,
    explanation: "El triángulo submandibular está formado por el borde posterior del milohioideo, el vientre anterior del digástrico y el hiogloso. Contiene la glándula submandibular, vasos faciales y el nervio lingual."
  },
  
  {
    id: 10313,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué rama específica irriga el milohioideo?",
    options: [
      "Arteria sublingual",
      "Arteria milohioidea",
      "Rama de la arteria lingual",
      "Arteria alveolar inferior"
    ],
    correctAnswer: 1,
    explanation: "La arteria milohioidea irriga específicamente el milohioideo. Emerge de la arteria alveolar inferior dentro del conducto milohioideo y proporciona irrigación al músculo, hueso mandibular y dientes molares."
  },
  
  {
    id: 10314,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Cómo se forma el asa milohioidea?",
    options: [
      "Nervio milohioideo y nervio lingual",
      "Nervio milohioideo y nervio alveolar inferior",
      "Nervio milohioideo y nervio digástrico",
      "Nervio milohioideo solo"
    ],
    correctAnswer: 0,
    explanation: "El asa milohioidea está formada por el nervio milohioideo (del trigémino) y el nervio lingual (también del trigémino). Este asa cruza sobre el milohioideo y proporciona inervación sensitiva a la lengua anterior."
  },
  
  {
    id: 10315,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VARIANTE,
    question: "¿Cuál es la variante anatómica más común del milohioideo?",
    options: [
      "Ausencia congénita",
      "Inserción doble en el hioides",
      "Fusión con genihioideo",
      "Tendón accesorio"
    ],
    correctAnswer: 3,
    explanation: "El tendón accesorio del milohioideo es la variante más común, ocurriendo en 10-15% de la población. Puede confundirse con patología en estudios de imagen y es más frecuente en el lado derecho."
  },
  
  {
    id: 10316,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué test evalúa la función del milohioideo?",
    options: [
      "Test de elevación hioidea",
      "Test de protrusión lingual",
      "Test de depresión mandibular",
      "Test de rotación cervical"
    ],
    correctAnswer: 0,
    explanation: "El test de elevación hioidea evalúa la función del milohioideo. El paciente eleva el hioides contra resistencia aplicada bajo el mentón. Debilidad indica lesión del nervio milohioideo o del músculo."
  },
  
  {
    id: 10317,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.EMBRIOLOGIA,
    question: "¿De qué arco faríngeo se desarrolla el milohioideo?",
    options: [
      "Primer arco faríngeo",
      "Segundo arco faríngeo",
      "Tercer arco faríngeo",
      "Mesénquima mandibular"
    ],
    correctAnswer: 0,
    explanation: "El milohioideo se desarrolla del primer arco faríngeo (arco mandibular), al igual que otros músculos derivados del mesénquima mandibular. Comparte origen embriológico con los músculos masticatorios."
  },
  
  {
    id: 10318,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.HISTOLOGIA,
    question: "¿Qué proporción aproximada de fibras musculares tiene el milohioideo?",
    options: [
      "90% fibras tipo I",
      "70% fibras tipo II",
      "60% tipo I, 40% tipo II",
      "50% tipo I, 50% tipo II"
    ],
    correctAnswer: 2,
    explanation: "El milohioideo tiene predominio de fibras tipo I (60%), adaptadas para funciones posturales y de precisión como la deglución y soporte lingual. Su composición refleja su papel en movimientos finos y sostenidos."
  },
  
  {
    id: 10319,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué estructura pasa por el conducto milohioideo?",
    options: [
      "Nervio milohioideo y arteria milohioidea",
      "Nervio lingual y vena lingual",
      "Nervio alveolar inferior",
      "Conducto de Wharton"
    ],
    correctAnswer: 0,
    explanation: "El conducto milohioideo contiene el nervio milohioideo y la arteria milohioidea. Este conducto atraviesa el hueso mandibular desde el agujero mandibular hasta emerger por el foramen milohioideo."
  },
  
  {
    id: 10320,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Por qué el milohioideo es importante en la fonación?",
    options: [
      "Controla la tensión de cuerdas vocales",
      "Estabiliza la base lingual",
      "Modula la resonancia",
      "Todas las anteriores"
    ],
    correctAnswer: 1,
    explanation: "El milohioideo estabiliza la base lingual durante la fonación, proporcionando una base firme para los movimientos de la lengua. Su contracción coordinada con otros músculos suprahioideos permite articulación precisa de sonidos."
  },
  
  // ========== NIVEL COMPLEJO (10) ==========
  
  {
    id: 10321,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con anestesia del piso de boca post-extracción molar. EMG confirma denervación milohioidea. ¿Qué nervio está lesionado?",
    options: [
      "Nervio alveolar inferior",
      "Nervio milohioideo",
      "Nervio lingual",
      "Nervio bucal"
    ],
    correctAnswer: 1,
    explanation: "La denervación del milohioideo indica lesión del nervio milohioideo durante cirugía oral. Este nervio puede lesionarse en extracciones de molares o cirugía del piso de boca. Causa debilidad en elevación hioidea y alteración de la deglución."
  },
  
  {
    id: 10322,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Paciente con disfagia orofaríngea. VFG muestra falta de elevación del hioides. ¿Qué músculo está afectado?",
    options: [
      "Genihioideo",
      "Milohioideo",
      "Estilohioideo",
      "Todos los anteriores"
    ],
    correctAnswer: 1,
    explanation: "La falta de elevación hioidea en videofluoroscopia indica afectación del milohioideo, principal elevador del hioides. Los demás músculos contribuyen pero el milohioideo es esencial. Es útil para diferenciar causas neuromusculares de obstructivas."
  },
  
  {
    id: 10323,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué abordaje se utiliza para biopsia del milohioideo?",
    options: [
      "Abordaje intraoral",
      "Abordaje submandibular",
      "Abordaje cervical anterior",
      "Abordaje endoscópico"
    ],
    correctAnswer: 1,
    explanation: "El abordaje submandibular permite biopsia directa del milohioideo. Se accede al triángulo submandibular para exponer el músculo. Es útil para evaluación de miopatías inflamatorias o neoplasias del suelo de la boca."
  },
  
  {
    id: 10324,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En RM cervical, ¿qué hallazgo confirma ruptura del milohioideo?",
    options: [
      "Engrosamiento muscular difuso",
      "Señal hiperintensa en T2 con disrupción fibrilar",
      "Atrofia global",
      "Calcificación del rafe medio"
    ],
    correctAnswer: 1,
    explanation: "La ruptura del milohioideo muestra señal hiperintensa en T2-STIR con disrupción fibrilar en el sitio de ruptura. Es rara pero puede ocurrir por trauma directo o degeneración. Afecta la integridad del suelo de la boca."
  },
  
  {
    id: 10325,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué complicación puede causar la parálisis del milohioideo en la deglución?",
    options: [
      "Regurgitación nasal",
      "Aspiración por falta de elevación hioidea",
      "Impactación faríngea",
      "Todas las anteriores"
    ],
    correctAnswer: 1,
    explanation: "La parálisis del milohioideo causa aspiración por falta de elevación hioidea, impidiendo la apertura epiglótica adecuada. El bolo alimenticio puede entrar en vías aéreas durante la deglución. Es una complicación grave en lesiones trigeminales."
  },
  
  {
    id: 10326,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con tumor del piso de boca presenta debilidad milohioidea unilateral. ¿Qué movimiento está limitado?",
    options: [
      "Apertura de boca",
      "Elevación hioidea",
      "Protrusión lingual",
      "Movimiento lateral mandibular"
    ],
    correctAnswer: 1,
    explanation: "La debilidad milohioidea limita la elevación hioidea durante deglución y fonación. El paciente presenta disfagia y voz nasal por incompetencia velofaríngea secundaria. Puede requerir modificación de dieta y terapia de deglución."
  },
  
  {
    id: 10327,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Evaluación EMG muestra denervación selectiva del milohioideo. ¿Qué segmento neurológico sugiere?",
    options: [
      "Núcleo motor trigeminal",
      "Rama mandibular del trigémino",
      "Ganglio de Gasser",
      "Nervio alveolar inferior"
    ],
    correctAnswer: 1,
    explanation: "La denervación selectiva del milohioideo indica lesión de la rama mandibular del trigémino proximal al foramen oval. Lesiones más distales afectarían múltiples músculos masticatorios. La EMG ayuda a localizar el nivel de lesión."
  },
  
  {
    id: 10328,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué técnica se utiliza para reconstrucción del suelo de boca post-resección milohioidea?",
    options: [
      "Colgajo miocutáneo",
      "Injerto libre radial",
      "Colgajo nasolabial",
      "Todas las anteriores"
    ],
    correctAnswer: 1,
    explanation: "El injerto libre radial se utiliza para reconstrucción del suelo de la boca post-resección milohioidea. Proporciona tejido fino y flexible para restaurar la función deglútoria y la integridad oral. Es la técnica más utilizada en reconstrucción microvascular."
  },
  
  {
    id: 10329,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En ecografía del piso de boca, ¿qué maniobra evalúa la contractilidad del milohioideo?",
    options: [
      "Elevación lingual pasiva",
      "Deglución activa",
      "Apertura de boca contra resistencia",
      "Movimiento de protrusión mandibular"
    ],
    correctAnswer: 1,
    explanation: "La ecografía durante deglución activa evalúa la contractilidad del milohioideo. Muestra elevación del músculo y aproximación al hiogloso. Es útil para evaluar función en pacientes con disfagia o sospecha de parálisis neuromuscular."
  },
  
  {
    id: 10330,
    muscle: 'milohioideo',
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "Paciente con hipertrofia compensatoria del milohioideo contralateral. ¿Qué explica este hallazgo?",
    options: [
      "Parálisis homolateral",
      "Sobrecarga funcional",
      "Adaptación por tumor",
      "Todas las anteriores"
    ],
    correctAnswer: 3,
    explanation: "La hipertrofia compensatoria del milohioideo contralateral ocurre por parálisis homolateral, sobrecarga funcional en movimientos unilaterales y adaptación por tumor. El músculo contralateral se hipertrofia para mantener la función deglútoria y estabilidad oral."
  }
];
